/* eslint-disable react/prop-types */
import React from 'react';
import { ReactComponent as ImportIcon } from 'assets/icons/New/import-icon.svg';
import { ReactComponent as ExportIcon } from 'assets/icons/New/export-icon.svg';
import { ReactComponent as UserGroupIcon } from 'assets/icons/New/user-group-icon.svg';
import NPageHeader from 'components/New/Page/PageHeader';
import ATabs from 'components/Antd/Tabs';
import AButton from 'components/Antd/Button';
import ABadge from 'components/Antd/Badge';
import ATabContent from 'components/Antd/Tabs/TabContent';
import ColumnActions from 'components/Antd/Table/ColumnActions';
import ATabExtraContent from 'components/Antd/Tabs/TabExtraContent';
import ATable from 'components/Antd/Table';
import NFilterBar from 'components/New/FilterBar';
import classes from './Example.module.scss';

const renderColumn = (val) => val || '-';

const Example = () => {
  const dropdownItems = [
    {
      key: '1',
      label: 'Edit',
      onClick: () => {},
    },
    {
      key: '2',
      label: 'Delete',
      onClick: () => {},
    },
  ];
  const columns = [
    {
      title: 'Supplier Name / ID / Tag',
      dataIndex: 'name',
      fixed: 'left',
      render: renderColumn,
    },
    {
      title: 'Location',
      dataIndex: 'name',
      fixed: 'left',
      render: renderColumn,
    },
    {
      title: 'Product Category',
      dataIndex: 'name',
      fixed: 'left',
      render: renderColumn,
    },
    {
      title: 'Status',
      dataIndex: 'name',
      fixed: 'left',
      render: renderColumn,
    },
    {
      title: 'Connect Status',
      dataIndex: 'name',
      fixed: 'left',
      render: renderColumn,
    },
    {
      title: 'Rating',
      dataIndex: 'name',
      fixed: 'left',
      render: renderColumn,
    },
    {
      title: 'Last Modified',
      dataIndex: 'name',
      fixed: 'left',
      render: renderColumn,
    },
    {
      title: '',
      dataIndex: 'name',
      fixed: 'left',
      render: () => <ColumnActions items={dropdownItems} />,
      width: 50,
    },
  ];
  const tabItems = [
    {
      key: '1',
      label: (
        <>
          <span>Supllier</span>
          <ABadge count={8} />
        </>
      ),
      children: (
        <ATabContent>
          <NFilterBar />
          <ATable
            columns={columns}
            dataSource={[{}]}
            standardPagination
            box
            pagination={{
              total: 1000,
            }} newStyle
          />
        </ATabContent>
      ),
    },
    {
      key: '2',
      label: (
        <>
          <span>Factory</span>
          <ABadge count={8} />
        </>
      ),
      children: <ATabContent>Factory Content</ATabContent>,
    },
  ];
  return (
    <div className={classes.wrapper}>
      <NPageHeader
        title={
          <>
            <UserGroupIcon /> <span>Supplier/ Factory Management</span>
          </>
        }
      />
      <ATabs
        items={tabItems}
        tabBarExtraContent={{
          right: (
            <ATabExtraContent>
              <AButton icon={<ExportIcon />} type="link">
                Export Suppliers
              </AButton>
              <AButton icon={<ImportIcon />} type="link">
                Import Suppliers
              </AButton>
              <AButton type="primary">Create Supplier</AButton>
              <AButton type="primary">Invite Supplier</AButton>
            </ATabExtraContent>
          ),
        }}
      />
    </div>
  );
};

export default Example;
